import { IDefineCommand } from 'core-ts-types';

angular
  .module('about')
  .service(
    'getServerDeployDetails',
    ($http: ng.IHttpService, defineCommand: IDefineCommand, appConfigModel: any, log: any) => {
      return defineCommand('getServerDeployDetails', (deferred) => {
        $http
          .get('/static/about_server.json')
          .then((envConfig: any) => {
            deferred.resolve(envConfig);
          })
          .catch((err) => {
            deferred.reject(err);
            log.error(err);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-settings/src/about/commands/get_server_deploy_detials.ts